import React, { useState } from 'react';
import './Dashboard.css';
import { MdArrowBack } from 'react-icons/md';
import { Link } from 'react-router-dom';

const SkillBuilder = () => {
  const [newSkill, setNewSkill] = useState('');
  const [skills, setSkills] = useState([
    {
      id: 1,
      name: 'Comunicação Assertiva',
      progress: 65,
      resources: 3,
      icon: 'fas fa-comments',
      description: 'Aprenda a expressar suas ideias de forma clara e respeitosa'
    },
    {
      id: 2,
      name: 'Gestão de Tempo',
      progress: 40,
      resources: 2,
      icon: 'fas fa-clock',
      description: 'Organize seu tempo para ser mais produtivo'
    },
    {
      id: 3,
      name: 'Liderança Inclusiva',
      progress: 20,
      resources: 1,
      icon: 'fas fa-users',
      description: 'Aprenda a liderar equipes diversas com eficiência'
    }
  ]);

  const [activeSkill, setActiveSkill] = useState(skills[0]); // Começa com a primeira habilidade selecionada
  const [steps, setSteps] = useState([
    { id: 1, title: 'Definir Objetivos', description: 'Estabeleça metas claras para o que deseja alcançar', completed: true },
    { id: 2, title: 'Planejar Aprendizado', description: 'Organize como e quando vai estudar', completed: false },
    { id: 3, title: 'Estudar Recursos', description: 'Acesse os materiais recomendados', completed: false },
    { id: 4, title: 'Praticar', description: 'Aplique o que aprendeu em exercícios', completed: false },
    { id: 5, title: 'Avaliar Progresso', description: 'Verifique o que aprendeu e o que precisa revisar', completed: false }
  ]);
  const [currentStep, setCurrentStep] = useState(0);
  const any = false;
  const handleAddSkill = () => {
    if (newSkill.trim()) {
      const newSkillObj = {
        id: skills.length + 1,
        name: newSkill,
        progress: 0,
        resources: 0,
        icon: 'fas fa-star',
        description: 'Nova habilidade que você deseja desenvolver'
      };
      setSkills([...skills, newSkillObj]);
      setNewSkill('');
    }
  };


  const [userData, setUserData] = useState({
    name: "Ana Silva",
    role: "Desenvolvedora Front-end",
    progress: 65,
    modulesCompleted: 3,
    skills: ["React", "Comunicação", "Gestão de Tempo", "Inteligência Emocional"],
    emotionalState: {
      resilience: 78,
      empathy: 85,
      selfAwareness: 70,
      stressManagement: 65
    },
    careerGoals: ["Sênior em 2 anos", "Liderança técnica", "Palestrante"],
    learningPath: [
      { id: 1, name: "Orientação Profissional", progress: 100 },
      { id: 2, name: "Inteligência Emocional", progress: 85 },
      { id: 3, name: "Oratória", progress: 45 },
      { id: 4, name: "Desenvolvimento Pessoal", progress: 30 }
    ],
    recentAchievements: [
      { id: 1, title: "Certificado em Gestão Emocional", date: "15/06/2023" },
      { id: 2, title: "Palestra em evento da empresa", date: "05/06/2023" },
      { id: 3, title: "Feedback positivo de liderança", date: "28/05/2023" }
    ],
    notifications: [
      { id: 1, title: "Novo módulo disponível", content: "Liderança Inclusiva está disponível", read: false },
      { id: 2, title: "Atualização no currículo", content: "3 novas habilidades foram adicionadas", read: true },
      { id: 3, title: "Feedback recebido", content: "Seu colega deixou um feedback positivo", read: false }
    ]
  });

  const handleSelectSkill = (skill) => {



    setActiveSkill(skill);
    // Resetar os passos para a nova habilidade
    setSteps([
      { id: 1, title: 'Definir Objetivos', description: 'Estabeleça metas claras para o que deseja alcançar', completed: true },
      { id: 2, title: 'Planejar Aprendizado', description: 'Organize como e quando vai estudar', completed: false },
      { id: 3, title: 'Estudar Recursos', description: 'Acesse os materiais recomendados', completed: false },
      { id: 4, title: 'Praticar', description: 'Aplique o que aprendeu em exercícios', completed: false },
      { id: 5, title: 'Avaliar Progresso', description: 'Verifique o que aprendeu e o que precisa revisar', completed: false }
    ]);
    setCurrentStep(0);
  };

  const handleCompleteStep = () => {


    if (currentStep < steps.length - 1) {
      const updatedSteps = [...steps];
      updatedSteps[currentStep].completed = true;
      setSteps(updatedSteps);
      setCurrentStep(currentStep + 1);

      // Atualizar progresso da habilidade
      if (activeSkill) {
        const updatedSkills = skills.map(skill =>
          skill.id === activeSkill.id
            ? { ...skill, progress: Math.min(100, skill.progress + 20) }
            : skill
        );
        setSkills(updatedSkills);
        setActiveSkill({ ...activeSkill, progress: Math.min(100, activeSkill.progress + 20) });
      }
    }
  };

  const handleAddResource = () => {
    if (activeSkill) {
      const updatedSkills = skills.map(skill =>
        skill.id === activeSkill.id
          ? { ...skill, resources: skill.resources + 1 }
          : skill
      );
      setSkills(updatedSkills);
      setActiveSkill({ ...activeSkill, resources: activeSkill.resources + 1 });
    }
  };

  if (any) {
    handleAddResource();
    setUserData();
  }

  return (
    <div className="skill-builder">
      <header className="dashboard-header" >
        <div className="header-left">
          {/* Botão hamburger para mobile */}
          <Link to={'/dashboard'}
            className="hamburger-btn-dstkp"
          >
            <MdArrowBack className="mr-2" />
          </Link>
          <h1>Meu Espaço de Desenvolvimento</h1>
          <p>Bem-vindo à sua jornada de autoconhecimento e crescimento</p>
        </div>
        <div className="header-right">
          <div className="notifications">
            <i className="fas fa-bell"></i>
            <span className="badge">{userData.notifications.filter(n => !n.read).length}</span>
          </div>
          <div className="user-menu">
            <div className="user-avatar small">
              <div className="avatar-initials">AS</div>
            </div>
          </div>
        </div>
      </header>
      <div style={{ marginTop: "10rem" }} className="builder-header ">
        <h2>Construtor de Habilidades</h2>
        <p>Siga os passos para desenvolver qualquer habilidade que desejar!</p>
      </div>

      <div className="builder-container">
        {/* Painel de Habilidades */}
        <div className="skills-panel">
          <div className="panel-header">
            <h3>Suas Habilidades</h3>
            <div className="add-skill">
              <input
                type="text"
                value={newSkill}
                onChange={(e) => setNewSkill(e.target.value)}
                placeholder="Adicione uma nova habilidade"
              />
              <button onClick={handleAddSkill}>
                <i className="fas fa-plus"></i> Adicionar
              </button>
            </div>
          </div>

          <div className="skills-list">
            {skills.map(skill => (
              <div
                key={skill.id}
                className={`skill-item ${activeSkill?.id === skill.id ? 'active' : ''}`}
                onClick={() => handleSelectSkill(skill)}
              >
                <div className="skill-icon">
                  <i className={skill.icon}></i>
                </div>
                <div className="skill-info">
                  <h4>{skill.name}</h4>
                  <p>{skill.description}</p>
                </div>
                <div className="skill-progress">
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{ width: `${skill.progress}%` }}
                    ></div>
                  </div>
                  <span>{skill.progress}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Painel de Desenvolvimento */}
        <div className="development-panel">
          {activeSkill ? (
            <>
              <div className="active-skill-header">
                <div className="skill-title">
                  <i className={activeSkill.icon}></i>
                  <h3>{activeSkill.name}</h3>
                </div>
                <div className="overall-progress">
                  <div className="progress-circle">
                    <div className="progress-text">{activeSkill.progress}%</div>
                  </div>
                </div>
              </div>

              <div className="development-steps">
                <h4>Passo a Passo:</h4>
                <div className="steps-container">
                  {steps.map((step, index) => (
                    <div
                      key={step.id}
                      className={`step-item ${step.completed ? 'completed' : ''} ${index === currentStep ? 'current' : ''}`}
                    >
                      <div className="step-number">{index + 1}</div>
                      <div className="step-content">
                        <h5>{step.title}</h5>
                        <p>{step.description}</p>
                      </div>
                      <div className="step-actions">
                        {index === currentStep && !step.completed && (
                          <button className="btn-complete" onClick={handleCompleteStep}>
                            Concluir este passo
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="development-resources">
                <h4>Recursos para te ajudar:</h4>
                <div className="resources-grid">
                  <div className="resource-card">
                    <div className="resource-icon">
                      <i className="fas fa-video"></i>
                    </div>
                    <div className="resource-content">
                      <h5>Vídeo Aula: Introdução</h5>
                      <p>Assista para entender os conceitos básicos</p>
                      <button className="btn-view">
                        <i className="fas fa-play"></i> Assistir
                      </button>
                    </div>
                  </div>

                  <div className="resource-card">
                    <div className="resource-icon">
                      <i className="fas fa-file-alt"></i>
                    </div>
                    <div className="resource-content">
                      <h5>Guia Prático</h5>
                      <p>Baixe este PDF com exercícios e exemplos</p>
                      <button className="btn-view">
                        <i className="fas fa-download"></i> Baixar
                      </button>
                    </div>
                  </div>

                  <div className="resource-card">
                    <div className="resource-icon">
                      <i className="fas fa-tasks"></i>
                    </div>
                    <div className="resource-content">
                      <h5>Atividade Prática</h5>
                      <p>Exercício para aplicar o que você aprendeu</p>
                      <button className="btn-view">
                        <i className="fas fa-pencil-alt"></i> Iniciar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="development-help">
                <h4>Precisa de ajuda?</h4>
                <p>Nosso assistente está disponível para te guiar em cada passo:</p>
                <button className="btn-help">
                  <i className="fas fa-comments"></i> Falar com o Assistente
                </button>
              </div>
            </>
          ) : (
            <div className="select-skill-prompt">
              <i className="fas fa-hand-pointer"></i>
              <h3>Selecione uma habilidade para começar</h3>
              <p>Escolha uma habilidade na lista ao lado ou adicione uma nova para iniciar seu desenvolvimento</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SkillBuilder;